import { useContext, useEffect, useState } from 'react';
import Sidebar from '../../../components/ConsumerSidebar/ConsumerSidebar';
import './HelpAndSupport.css';
import apiStatusConstants from '../../../config/apiStatusConstants';
import TicketItem from '../TicketItem/TicketItem';
import {
  ProfileContext,
  ProfileContextProps,
  Ticket,
} from '../../../context/ProfileContext';
import StyledButton from '../../../components/Button/Button';
import { useNavigate } from 'react-router-dom';
import { getTickets } from '../../../services/NetworkServices';
import ApiStatus from '../../../config/apiStatusConstants';
import {
  Box,
  Typography,
  Container,
  AppBar,
  Toolbar,
  Pagination,
} from '@mui/material';
import { getStage } from '../../../services/NetworkServices';
import { storeStageNumber } from '../../../utils/auth-token-utils/cookie';

import LogoutPopup from '../../../components/Inputs/LogoutPopup';
import TemporaryDrawer from '../../../components/TemporaryDrawer/TemporaryDrawer';
import LeftArrow from '../../../assets/Left 1.svg';
import RightArrow from '../../../assets/RightArrow.svg';

const HelpAndSupport: React.FC = () => {
  const [apiStatus, setApiStatus] = useState(ApiStatus.INITIAL);
  const [errorMsg, setErrorMsg] = useState<string>('');
  const [currentPage, setCurrentPage] = useState<number>(1); // Start on page 1
  const itemsPerPage = 5;
  const [totalRecords, setTotalRecords] = useState<number>(0);

  const { ticketsList, handleTicketsList, showLogoutPopup } = useContext(
    ProfileContext,
  ) as ProfileContextProps;
  const navigate = useNavigate();

  const handleNewTicket = () => {
    navigate('/participant/createTicket');
  };

  const platform = 'web';

  useEffect(() => {
    const fetchStageDetails = async () => {
      try {
        console.log('inside use effect');
        const response = await getStage();
        const data = await response.data;
        if (data) {
          console.log('stage is', data.data.stage);
          const stage = data.data.stage;
          storeStageNumber(stage);
          if (stage === '1') {
            navigate('/participant/createProfile');
          }
          if (stage === '2') {
            navigate('/participant/inviteBabysitter');
          }
          if (stage === '3') {
            navigate('/participant/selectplan');
          }
        }
      } catch (error) {
        console.error('Error fetching profile details:', error);
      }
    };
    fetchStageDetails();
  }, [navigate]);

  useEffect(() => {
    const fetchTicketDetails = async (page: number, limit: number) => {
      try {
        const response = await getTickets(page, limit, { platform });
        const data = await response.data;
        console.log('data is', data);
        if (data) {
          console.log('success');
          setApiStatus(ApiStatus.SUCCESS);
          handleTicketsList(data.data.ticketsList);
          setTotalRecords(data.data.count);
        }
      } catch (error: any) {
        console.log('error is ', error);
        console.log('error is ', error.response?.data.error?.message);
        setApiStatus(ApiStatus.FAILURE);
        setErrorMsg(
          error.response?.data?.error?.message ||
            'Something went wrong. Please try again.',
        );
      }
    };
    fetchTicketDetails(currentPage, itemsPerPage);
  }, [currentPage, itemsPerPage]);

  const handleBackClick = () => {
    navigate('/participant/dashboard');
  };

  const handleNextPage = () => {
    setCurrentPage((prev) => prev + 1);
  };

  const handlePreviousPage = () => {
    if (currentPage > 1) {
      setCurrentPage((prev) => prev - 1);
    }
  };

  return (
    <>
      {showLogoutPopup && <div className="backdrop"> </div>}
      <Box className={`editProfile ${showLogoutPopup ? 'popup-active' : ''}`}>
        <Box className="account-details">
          <Box
            sx={{
              display: { xs: 'block', sm: 'flex' },
              height: { xs: '100vh', sm: '100vh' },
              overflow: { xs: 'auto', sm: 'hidden' },
            }}
          >
            <AppBar
              position="static"
              sx={{
                display: { xs: 'block', sm: 'none' },
                backgroundColor: 'black',
              }}
            >
              <Toolbar sx={{ background: 'black' }}>
                <TemporaryDrawer />
              </Toolbar>
            </AppBar>
            <Box
              sx={{
                display: { xs: 'none', sm: 'flex' },
                width: { xs: '0%', sm: '35%', md: '28%' },
                justifyContent: 'space-between',
                flexDirection: 'column',
              }}
            >
              <Box
                sx={{
                  height: '100%',
                  marginLeft: { sm: 2, md: 14 },
                  marginTop: { sm: 2, md: 4 },
                  marginBottom: { sm: 30, md: 4 },
                }}
              >
                <Sidebar />
              </Box>
            </Box>
            <Box
              sx={{
                width: { xs: '100%', sm: '65%', md: '72%' },
                flexGrow: 1,
                overflow: 'auto',
                height: '100%',
                paddingY: 4,
              }}
            >
              <Container>
                <Box sx={{ display: { xs: 'block', sm: 'none' } }}>
                  <img
                    src={LeftArrow}
                    onClick={handleBackClick}
                    className="arrow-sm"
                  />
                </Box>
                <Box className="edit-profile-pic">
                  <Box
                    sx={{
                      display: 'flex',
                      flexDirection: 'column',
                      justifyContent: 'flex-start',
                      paddingTop: '10px',
                      width: { xs: '100%', sm: '80%', md: '60%' },
                    }}
                  >
                    <Box className="tickets-list">
                      <Typography
                        variant="h5"
                        sx={{
                          textAlign: 'left',
                          color: 'white',
                          fontFamily: 'Opensans',
                          paddingBottom: '10px',
                        }}
                      >
                        Raised Tickets
                      </Typography>
                      {ticketsList &&
                        ticketsList.map((ticket: Ticket) => (
                          <TicketItem key={ticket.id} ticket={ticket} />
                        ))}
                      <StyledButton
                        onClick={handleNewTicket}
                        sx={{
                          marginTop: '19vh',
                          marginBottom: '2vh',
                          display: 'block',
                        }}
                      >
                        Raise a New Ticket
                      </StyledButton>
                    </Box>
                    {totalRecords > 5 && (
                      <div className="table_pagination_container">
                        <div
                          className="pagination-btn-wrapper"
                          onClick={handlePreviousPage}
                        >
                          <img src={LeftArrow} alt="Previous" /> Previous
                        </div>
                        <div>
                          <Pagination
                            count={Math.ceil(totalRecords / itemsPerPage)} // Use dynamic page count
                            page={currentPage} // Controlled page value
                            onChange={(e, value) => setCurrentPage(value)} // Update page on pagination change
                            color="primary"
                            sx={{
                              '& .MuiPaginationItem-root': {
                                color: '#FFFFFF66', // Default color for other pages
                              },
                              '& .Mui-selected': {
                                color: 'white', // Text color for selected page
                              },
                            }}
                          />
                        </div>
                        <div
                          className="pagination-btn-wrapper"
                          onClick={handleNextPage}
                        >
                          Next <img src={RightArrow} alt="Next" />
                        </div>
                      </div>
                    )}
                  </Box>
                </Box>
              </Container>
            </Box>
          </Box>
        </Box>
      </Box>

      {showLogoutPopup && <LogoutPopup />}
    </>
  );
};

export default HelpAndSupport;
